import { combineReducers } from "redux";
import createPost from './actions/createPost';
import deletePost from './actions/deletePost';
import getEssentialServicesGeojson from './actions/getEssentialServicesGeojson';
import getInformativesGeojson from './actions/getInformativesGeojson';
import getPostById from './actions/getPostById';
import getPostsPaginated from './actions/getPostsPaginated';
import publishPost from './actions/publishPost';
import updatePost from './actions/updatePost';

export const posts = combineReducers({
    getPostsPaginated,
    createPost,
    updatePost,
    deletePost,
    getPostById,
    getEssentialServicesGeojson,
    getInformativesGeojson,
    publishPost
});
